import React, { Component, Fragment } from "react";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const MONTH_NAMES = [
  "January", "February", "March", "April", "May", "June",
  "July", "August", "September", "October", "November", "December",
];

// month.month looks like "April,2026" — parse into a real Date so months
// sort chronologically (newest first) instead of alphabetically.
function parseMonthId(id) {
  const [monthName, year] = String(id).split(",");
  const monthIndex = MONTH_NAMES.indexOf((monthName || "").trim());
  return new Date(parseInt(year, 10) || 0, monthIndex >= 0 ? monthIndex : 0, 1);
}

export class Datatable extends Component {
  render() {
    const { myData, history, type } = this.props;

    const rows = [...(myData || [])].sort(
      (a, b) => parseMonthId(b.month) - parseMonthId(a.month)
    );

    return (
      <Fragment>
        <div className="ln-table-wrap">
          <table className="table ln-table">
            <thead>
              <tr>
                <th scope="col">Month</th>
                <th scope="col" className="ln-col-action">Inspect</th>
              </tr>
            </thead>
            <tbody>
              {rows.length === 0 ? (
                <tr>
                  <td colSpan={2} className="ln-empty">
                    No records yet.
                  </td>
                </tr>
              ) : (
                rows.map((month, i) => (
                  <tr key={i}>
                    <td>{month.month}</td>
                    <td className="ln-col-action">
                      <button
                        type="button"
                        className="ln-icon-btn"
                        onClick={() => {
                          history.push(`/expense/loans/${type}-${month.month}`);
                        }}
                      >
                        <i className="fa fa-eye"></i>
                      </button>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
        <ToastContainer />
      </Fragment>
    );
  }
}

export default Datatable;
